var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":_vm.id,"queryDate":_vm.queryDate,"queryType":_vm.queryType}})
}
var staticRenderFns = []

export { render, staticRenderFns }